module.exports = __webpack_public_path__ + "static/media/CTLI_4-111w.3ac29aa0.webp";